module.exports = __webpack_public_path__ + "static/media/comment-alt-music.306acc13.svg";